





























































































































/* General */
import Vue from 'vue'
import MailboxSettingsLayout from '@/layouts/mailbox-settings-layout.vue'

/* Mixins */

/* Components */
import EntitySettingsLoading from '@/layouts/entity-settings-loading.vue'

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import { IMailboxesOutputIncomingEmailSettings } from '@/api/types/response.types'

/* API */
import MailboxesAPI from '@/api/modules/mailboxes.api'
import { IMailboxesInputIncomingEmailSettings } from '@/api/types/request.types'

export default Vue.extend({
  name: 'MailboxSettingsConversationRules',

  metaInfo(): any {
    return {
      title: `Conversation Rules - ${this.settings.name}`,
    }
  },

  components: {
    MailboxSettingsLayout,
    EntitySettingsLoading,
  },

  data() {
    return {
      ColorAssistant,
      isLoading: true,
      isSubmitting: false,
      enableSpamCheck: true,
      keepStatus: false,
      settings: {
        name: '',
      } as IMailboxesOutputIncomingEmailSettings,
      formData: {} as IMailboxesInputIncomingEmailSettings,
      rules: {
        inactiveUpdateStatusID: [
          {
            validator: (rule: any, value: any, callback: any) => {
              // @ts-ignore
              if (this.keepStatus && !value) {
                callback(new Error('Select a status'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
      },
    }
  },

  computed: {
    id(): number {
      return parseInt(this.$route.params.id, 10)
    },
  },

  watch: {
    'formData.inactiveUpdateStatusID'(value): void {
      if (value !== null) {
        this.keepStatus = true
      }
    },
    keepStatus(value): void {
      if (value === false) {
        this.formData.inactiveUpdateStatusID = null
        // @ts-ignore
        this.$refs.mailboxForm.clearValidate(['inactiveUpdateStatusID'])
      }
    },
  },

  async created() {
    this.isLoading = true
    await this.getConversationRulesInfo()
    this.isLoading = false
  },

  methods: {
    async getConversationRulesInfo() {
      try {
        this.settings = await MailboxesAPI.get_IncomingEmailSettings(this.id)
        this.enableSpamCheck = !this.settings.bypassSpamCheck
        this.formData = {
          defaultAssigneeID: this.settings.defaultAssigneeID,
          defaultStatusID: this.settings.defaultStatusID,
          defaultPriorityID: this.settings.defaultPriorityID,
          listDefaultTags: this.settings.listDefaultTags,
          listDefaultJobAppointeeMappings: this.settings.listDefaultJobAppointees.map(
            dja => ({
              jobID: dja.job.id,
              appointeeID: dja.appointee ? dja.appointee.id : 0,
            }),
          ),
          inactiveUpdateStatusID: this.settings.inactiveUpdateStatusID,
          bypassSpamCheck: this.settings.bypassSpamCheck,
        } as IMailboxesInputIncomingEmailSettings
      } catch (error) {
        this.$error.emit(error)
      }
    },

    /**
     * Validate all attributes before save
     */
    validateToSave(): boolean {
      // @ts-ignore
      this.$refs.mailboxForm.validate((valid: boolean) => {
        if (valid) {
          this.save()
          return true
        }
      })
      return false
    },

    /**
     * Save new data
     */
    async save(): Promise<void> {
      try {
        this.isSubmitting = true
        this.formData.bypassSpamCheck = !this.enableSpamCheck
        const response = await MailboxesAPI.post_IncomingEmailSettings(
          this.id,
          this.formData,
        )
        this.$messaging.showSuccess(response.message)
      } catch (error) {
        this.$error.emit(error, true)
        await this.getConversationRulesInfo()
      } finally {
        this.isSubmitting = false
      }
    },
  },
})
